export default {
    poweredBy: "Offerto da"
}